import type { Translation } from "./types";

const ko: Translation = {
  home: {
    title: "AI내동생",
    subtitle: "빌드하는 시간이야!",
  },
  about: {
    link: "서비스 소개",
    title: "서비스 소개",
    subtitle: "AI 내동생을 만드는 개인 프로젝트와 약속",
  },
  navigation: {
    kr: "한국어",
    es: "스페인어",
    en: "영어",
    zh: "중국어",
  },
  menu: {
    explain: "설명하기",
    chat: "채팅",
    quiz: "퀴즈",
    progress: "진도",
  },
  auth: {
    login: {
      title: "로그인",
      subtitle: "계정 정보를 입력해주세요",
      email: "이메일",
      password: "비밀번호",
      forgotPassword: "비밀번호를 잊으셨나요?",
      loginButton: "로그인",
      emailNotConfirmed: "이메일이 확인되지 않았습니다",
      resendConfirmation: "확인 이메일 재전송",
      noAccount: "계정이 없으신가요?",
      signUp: "회원가입",
      emailPlaceholder: "example@email.com",
      passwordPlaceholder: "비밀번호를 입력하세요",
    },
    join: {
      title: "계정 만들기",
      subtitle: "계정 생성을 위해 정보를 입력해주세요",
      name: "이름",
      email: "이메일",
      password: "비밀번호",
      confirmPassword: "비밀번호 확인",
      marketingConsent: "마케팅 이메일 수신 동의",
      termsAgreement: "이용약관 및 개인정보처리방침에 동의합니다",
      termsOfService: "이용약관",
      privacyPolicy: "개인정보처리방침",
      createAccount: "계정 만들기",
      accountCreated: "계정이 생성되었습니다!",
      emailVerificationRequired:
        "이메일 확인이 필요합니다. 이메일을 확인해주세요.",
      alreadyHaveAccount: "이미 계정이 있으신가요?",
      signIn: "로그인",
      namePlaceholder: "홍길동",
      emailPlaceholder: "example@email.com",
      passwordHint: "최소 8자 이상이어야 합니다.",
      passwordPlaceholder: "비밀번호를 입력하세요",
      confirmPasswordPlaceholder: "비밀번호를 다시 입력하세요",
      and: "및",
      agreeTo: "에 동의합니다",
    },
    forgotPassword: {
      title: "비밀번호를 잊으셨나요?",
      subtitle: "이메일을 입력하시면 재설정 링크를 보내드립니다.",
      email: "이메일",
      emailPlaceholder: "example@email.com",
      sendButton: "재설정 링크 전송",
      successMessage:
        "이메일을 확인하세요. 재설정 링크가 전송되었습니다. 이 탭을 닫으셔도 됩니다.",
    },
    newPassword: {
      title: "비밀번호 변경",
      subtitle: "새 비밀번호를 입력하고 확인해주세요.",
      password: "비밀번호",
      confirmPassword: "비밀번호 확인",
      passwordPlaceholder: "새 비밀번호를 입력하세요",
      confirmPasswordPlaceholder: "새 비밀번호를 다시 입력하세요",
      updateButton: "비밀번호 변경",
      successMessage: "비밀번호가 성공적으로 변경되었습니다!",
      passwordsMatchError: "비밀번호가 일치하지 않습니다",
      redirectMessage: "{{seconds}}초 후 로그인 페이지로 이동합니다...",
      goToLogin: "로그인하러 가기",
    },
  },
  landing: {
    hero: {
      quote:
        "가장 관심있는 분야를 가장 자유분방하고 독창적인 방법으로 공부하세요",
      author: "리처드 파인만",
    },
    intro: {
      title: "AI 내동생과 함께하는 자기주도 학습",
      subtitle:
        "설명하면 할수록 똑똑해지고, AI 동생이 귀엽고 날카롭게 피드백해줘요.",
      features: {
        organize: "아이디어 정리",
        practice: "설명 연습",
        learning: "깊이 있는 학습",
      },
      cta: "AI 동생 가르쳐주러 가기",
    },
    examples: {
      title: "사람들이 이렇게 설명했어요!",
      physics: {
        user: "중력은 물건이 떨어지는 힘이야",
        ai: "맞아! 사과도 땅으로 떨어졌지 🍎 그런데 왜 달은 안 떨어질까?",
      },
      biology: {
        user: "광합성은 식물이 빛으로 음식을 만드는 거야",
        ai: "우와! 🌱 그럼 식물은 요리사네! 어떤 재료들이 필요할까?",
      },
      politics: {
        user: "민주주의는 국민이 나라를 다스리는 거야",
        ai: "멋져! 🗳️ 그럼 모든 사람이 대통령이 될 수 있는 건가?",
      },
    },
    footer: {
      description:
        "AI 내동생은 지식을 말로 정리하는 힘을 길러주는 든든한 학습 파트너입니다.",
    },
  },
  contact: {
    title: "문의하기",
    subtitle:
      "궁금한 점이 있으시면 언제든지 연락주세요. 빠르게 답변드리겠습니다.",
    form: {
      name: "이름",
      email: "이메일",
      message: "메시지",
      namePlaceholder: "이름을 입력하세요",
      emailPlaceholder: "이메일을 입력하세요",
      messagePlaceholder: "문의 내용을 입력하세요",
      sendButton: "전송",
      captchaNote: "보안을 위해 Cloudflare Turnstile을 사용합니다.",
    },
    messages: {
      success: "문의가 성공적으로 전송되었습니다",
      error: "문의 전송 중 오류가 발생했습니다",
      captchaError: "보안 검증에 실패했습니다. 다시 시도해주세요.",
    },
  },
  legal: {
    privacyPolicy: "개인정보처리방침",
    termsOfService: "이용약관",
    youthPolicy: "청소년 보호정책",
    cookiePolicy: "쿠키 정책",
  },
  settings: {
    profile: {
      title: "프로필 편집 기능 (임시 비활성화)",
      subtitle: "프로필 정보를 확인할 수 있습니다.",
      name: "이름",
    },
    name: {
      title: "이름 변경",
      subtitle: "표시 이름을 변경하세요.",
      currentName: "현재 이름",
      newName: "새 이름",
      namePlaceholder: "새 이름을 입력하세요",
      changeButton: "이름 변경",
      successMessage: "이름이 성공적으로 변경되었습니다",
    },
    email: {
      title: "이메일 변경",
      titleAdd: "이메일 추가",
      subtitle: "이메일 주소를 변경하세요.",
      subtitleAdd: "계정에 이메일 주소를 추가하세요.",
      currentEmail: "현재 이메일",
      newEmail: "새 이메일",
      changeButton: "이메일 변경",
      addButton: "이메일 추가",
      successMessage:
        "이메일 업데이트 프로세스가 시작되었습니다. 확인 링크를 위해 기존 이메일을 확인해주세요.",
    },
    password: {
      title: "비밀번호 변경",
      titleAdd: "비밀번호 추가",
      subtitle: "비밀번호를 변경하세요.",
      subtitleAdd: "계정에 비밀번호를 추가하세요.",
      newPassword: "새 비밀번호",
      confirmPassword: "새 비밀번호 확인",
      changeButton: "비밀번호 변경",
      addButton: "비밀번호 추가",
      successMessage: "비밀번호가 업데이트되었습니다",
    },
    social: {
      title: "소셜 계정 연결",
      subtitle: "계정에 추가 인증 방법을 추가하거나 제거하세요.",
    },
    danger: {
      title: "위험 구역",
      confirmDelete: "계정을 삭제하고 싶다는 것을 확인합니다.",
      confirmIrreversible: "이 작업이 되돌릴 수 없다는 것을 이해합니다.",
      deleteButton: "계정 삭제",
    },
  },
  error: {
    title: "오류",
    errorCode: "오류 코드",
    goHome: "홈으로 이동",
    otpExpired: "이메일 링크가 유효하지 않거나 만료되었습니다",
    invalidLink:
      "이메일 링크가 만료되었거나 이미 사용되었습니다. 비밀번호 재설정을 다시 요청해주세요.",
  },
  common: {
    beta: "베타",
    betaNotice:
      "베타 서비스 운영 중입니다. 서비스 이용 중 불편사항이 있으시면 피드백 부탁드립니다.",
  },
};

export default ko;
